import { domainConnectFetchDomainService } from 'owa-domain-connect';
import { orchestrator } from 'satcheljs';
import setDomainState from '../mutators/setDomainState';
import { getDomainState } from '../actions/getDomainState';

export default orchestrator(getDomainState, async function getDomainState() {
    let response = await domainConnectFetchDomainService();
    setDomainState(response);
});
